import {
  AD_PREVIEW_SCROLLING,
  AD_COMPARER_UPDATE_ACCORDION_INDEX,
  AD_PREVIEW_UPDATE_ALL,
  AD_PREVIEW_INDETERMINATE_CAMPAIGNS,
  AD_PREVIEW_SELECT_CAMPAIGNS,
  AD_PREVIEW_SELECT_ADS,
  AD_PREVIEW_DISPLAY_CHECKBOX,
  AD_PREVIEW_DISPLAY_COPY_BUTTONS,
  AD_PREVIEW_COMPARE_MOBILE_DESKTOP,
  AD_PREVIEW_UPDATE_ACCORDION_INDEX,
  AD_PREVIEW_EXPAND_ALL,
  AD_PREVIEW_DISPLAY_CHECKBOX_MULTIQC
} from '../constants/ActionTypes';

const initialState = {
  displayCopyButtons: false,
  compareMobileDesktop: false,
  accordionIndex: {
    LINK_CLICKS: -1,
    VIDEO_VIEWS: -1,
    LEAD_GENERATION: -1,
    PRODUCT_CATALOG_SALES: -1,
    CONVERSIONS: -1,
    REACH: -1,
    MESSAGES: -1,
    POST_ENGAGEMENT: -1,
    OUTCOME_TRAFFIC: -1,
    OUTCOME_SALES: -1
  },
  expandAllAds: false,
  showCheckboxes: false,
  showCheckboxesMultiQc: false,
  selectedAds: {
    LINK_CLICKS: [],
    VIDEO_VIEWS: [],
    LEAD_GENERATION: [],
    PRODUCT_CATALOG_SALES: [],
    CONVERSIONS: [],
    REACH: [],
    MESSAGES: [],
    POST_ENGAGEMENT: [],
    OUTCOME_TRAFFIC: [],
    OUTCOME_SALES: []
  },
  checkedCampaigns: {
    PRODUCT_CATALOG_SALES: true,
    LEAD_GENERATION: true,
    VIDEO_VIEWS: true,
    LINK_CLICKS: true,
    CONVERSIONS: true,
    REACH: true,
    MESSAGES: true,
    POST_ENGAGEMENT: true,
    OUTCOME_TRAFFIC: true,
    OUTCOME_SALES: true
  },
  indeterminateCampaigns: {
    PRODUCT_CATALOG_SALES: false,
    LEAD_GENERATION: false,
    VIDEO_VIEWS: false,
    LINK_CLICKS: false,
    CONVERSIONS: false,
    REACH: false,
    MESSAGES: false,
    POST_ENGAGEMENT: false,
    OUTCOME_TRAFFIC: false,
    OUTCOME_SALES: false
  },
  moreInfoIndex: {},
  isScrolling: false
};
const run = {};

run[AD_PREVIEW_SCROLLING] = (state, action) =>
  Object.assign({}, state, {
    isScrolling: action.isScrolling
  });

run[AD_COMPARER_UPDATE_ACCORDION_INDEX] = (state, action) =>
  Object.assign({}, state, {
    moreInfoIndex: {
      ...state.moreInfoIndex,
      [action.parentAdId]: action.moreInfoIndex
    }
  });

run[AD_PREVIEW_UPDATE_ALL] = (state, action) =>
  Object.assign({}, state, {
    indeterminateCampaigns: action.indeterminateCampaigns,
    checkedCampaigns: action.checkedCampaigns,
    selectedAds: action.selectedAds
  });

run[AD_PREVIEW_INDETERMINATE_CAMPAIGNS] = (state, action) =>
  Object.assign({}, state, {
    indeterminateCampaigns: action.indeterminateCampaigns
  });

run[AD_PREVIEW_SELECT_CAMPAIGNS] = (state, action) =>
  Object.assign({}, state, {
    checkedCampaigns: action.selectedCampaigns
  });

run[AD_PREVIEW_SELECT_ADS] = (state, action) =>
  Object.assign({}, state, {
    selectedAds: action.selectedAds
  });

run[AD_PREVIEW_DISPLAY_CHECKBOX] = (state) =>
  Object.assign({}, state, {
    showCheckboxes: !state.showCheckboxes
  });

run[AD_PREVIEW_DISPLAY_CHECKBOX_MULTIQC] = (state) =>
  Object.assign({}, state, {
    showCheckboxesMultiQc: !state.showCheckboxesMultiQc
  });

run[AD_PREVIEW_DISPLAY_COPY_BUTTONS] = (state) =>
  Object.assign({}, state, {
    displayCopyButtons: !state.displayCopyButtons
  });

run[AD_PREVIEW_COMPARE_MOBILE_DESKTOP] = (state) =>
  Object.assign({}, state, {
    compareMobileDesktop: !state.compareMobileDesktop
  });

run[AD_PREVIEW_EXPAND_ALL] = (state) =>
  Object.assign({}, state, {
    expandAllAds: !state.expandAllAds
  });

run[AD_PREVIEW_UPDATE_ACCORDION_INDEX] = (state, action) =>
  Object.assign({}, state, {
    accordionIndex: {
      ...state.accordionIndex,
      [action.campaignKey]: action.accordionIndex
    }
  });

const adPreviewReducer = (state = initialState, action) => {
  if (action.type in run) {
    return run[action.type](state, action);
  }

  return state;
};

export default adPreviewReducer;



// WEBPACK FOOTER //
// ./src/reducers/ad.preview.js